import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { BrandMarkComponent } from '../../ui';
import { DOCUMENT } from '@angular/common';

/**
 * Struttura delle pagine pubbliche: il marchio nella versione principale con il payoff
 * (FR-054), il contenuto al centro e i collegamenti a termini d'uso e informativa privacy.
 */
@Component({
  selector: 'bs-public-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouterLink, BrandMarkComponent],
  host: { class: 'block min-h-dvh bg-stone-100 dark:bg-stone-950' },
  template: `
    <a
      href="#content"
      data-testid="skip-link"
      class="sr-only z-50 rounded-full bg-bsite-400 px-4 py-2 text-sm font-semibold text-ink focus:not-sr-only focus:fixed focus:left-4 focus:top-4"
      (click)="skipToContent($event)"
      >Vai al contenuto</a
    >
    <div class="flex min-h-dvh flex-col items-center px-4 py-8 sm:py-12">
      <header class="flex justify-center">
        <a
          routerLink="/"
          aria-label="B.Site, il cantiere condiviso: vai alla pagina iniziale"
          class="rounded-lg"
        >
          <bs-brand-mark variant="principale" [size]="44" />
        </a>
      </header>
      <main id="content" tabindex="-1" class="mt-6 flex w-full flex-1 justify-center outline-none">
        <router-outlet />
      </main>
      <footer class="mt-8 text-sm text-stone-600 dark:text-stone-300">
        <ul class="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
          <li>
            <a routerLink="/terms" class="underline-offset-4 hover:underline">Termini d'uso</a>
          </li>
          <li>
            <a routerLink="/privacy" class="underline-offset-4 hover:underline"
              >Informativa privacy</a
            >
          </li>
        </ul>
      </footer>
    </div>
  `,
})
export class PublicLayoutComponent {
  private readonly document = inject(DOCUMENT);

  protected skipToContent(event: Event): void {
    event.preventDefault();
    this.document.getElementById('content')?.focus();
  }
}
